








import { defineComponent, ref, useFetch, useMeta } from '@nuxtjs/composition-api'
import HotTopicList from '~/components/solepro/HotTopics/HotTopicList.vue';
import OtherHotTopics from '~/components/solepro/HotTopics/OtherHotTopics.vue';
import LandingHero from '~/components/solepro/LandingHero.vue';
import { useApi } from '~/composables';
import { GET_HOT_TOPIC_DETAIL, GET_HOT_TOPICS } from '~/modules/catalog/category/queries/solepro/gotTopics.gql';
import { useCategoryStore } from '~/modules/catalog/category/stores/category';
import { usePageStore } from '~/stores/page';
import { extendProductsForBox } from '~/utils/solepro/products';
import { hotTopicPageView } from '~/helpers/trackings/24orepro/pages';

export default defineComponent({
    components: {
        LandingHero,
        HotTopicList,
        OtherHotTopics
    },
    layout: '24orepro',
    setup() {

        const { query } = useApi();
        const { routeData } = usePageStore();
        const datas = ref();
        useFetch(async () => {
            const allCategories = ref([]);
            const categoryStore = useCategoryStore()
            const categoryResponse = await query(GET_HOT_TOPICS, { hotTopicsUid: routeData.uid });
            const hotTopic = categoryResponse.data['categories'].items[0]
            const { data } = await query(GET_HOT_TOPIC_DETAIL, { filter: { category_uid: { eq: routeData.uid } } });
            categoryStore.load()
            allCategories.value = categoryStore.rawCategories?.items[0].children;
            const items = extendProductsForBox(allCategories.value, data['products'].items).map(el => {
                return {
                    ...el,
                    box_description: el.hot_topics_description ?? el.box_description
                }
            });
            if(document){
                document.querySelector('title').innerHTML = hotTopic.name;
            }
            datas.value = {
                hotTopicsUid: allCategories.value.find(el=>el.name.toLowerCase()=='temi caldi')?.uid,
                title: hotTopic.name,
                subtitle: hotTopic.description,
               
                imageSrc: hotTopic.image,
                items
            }

            await hotTopicPageView(hotTopic.name)
        })
        return {
            datas
        }
    }
})
